import AccountsStore from 'common/stores/accounts/account.store';
import ProfileStore from 'common/stores/profile.store';
import AuthStore from 'common/stores/auth.store';
import AppStore from 'common/stores/app.store';
import ModalStore from 'common/stores/modal.store';
import BonusStore from 'common/stores/bonus.store';
import BalanceStore from './BackEnd/balance';
import ManageAccountStore from './BackEnd/manageAccount';
import OperationDetailsStore from './BackEnd/operationDetails';
import AnalyticsStore from './BackEnd/analytics';
import AnalyticsStore1 from './common/stores/analytics.store';

export const stores = {
  AnalyticsStore,
  AccountsStore,
  BalanceStore,
  ManageAccountStore,
  ProfileStore,
  AuthStore,
  OperationDetailsStore,
  AppStore,
  BonusStore,
  AnalyticsStore1,
  ModalStore,
};
